<template>
    <div class="w-100 product-info-container" :class="{'scroll-minimal-mode' : scrollMinimalMode}">
        <div v-if="renderLineInfo" class="info-main info-extras">
            <div class="line-of-infos">
                <div class="line-col main-col">
                    <h1 class="product-name"> {{ detailedInfo.name }} </h1>
                    <div v-show="!scrollMinimalMode" class="line-col icons-col">
                        <i v-show="showCopyLink" class="prz-link-share" @click="copyPageLink()"/>
                        <transition name="fade">
                            <div v-if="showCopyMsg" class="generic-tooltip"> {{ kStrings.kPRODUCT_LINK_COPIED }} </div>
                        </transition>
                        <Likes v-if="detailedInfo.likesData" :info="detailedInfo.likesData" :open-in-header="true" @change="onLikeChange"/>
                    </div>
                    <div v-show="scrollMinimalMode" class="line-col price-info">
                        <p class="final-price" :data-qa="price">
                            {{ price }}
                        </p>
                    </div>
                </div>
            </div>
            <transition enter-active-class="enter-active"
                        leave-active-class="leave-active"
                        @before-enter="beforeEnter"
                        @enter="enter"
                        @after-enter="afterEnter"
                        @before-leave="beforeLeave"
                        @leave="leave"
                        @after-leave="afterLeave">
                <div v-show="!scrollMinimalMode" class="line-of-infos three-cols">
                    <div class="line-col first price-info">
                        <p v-if="priceReference" class="crossed-price">
                            {{ priceReference }}
                        </p>
                        <p class="final-price" :data-qa="price">
                            {{ price }}
                            <i v-if="couponData" class="prz-info" @click="openCpgModal = true"/>
                        </p>
                    </div>
                    <div class="line-col middle points-info" @click="goToPointsUrl()">
                        <span v-if="detailedInfo.superPoints" class="best-points" :class="classSuperPoints"/>
                        <i v-else class="prz-prozis-points"/>
                        <span class="points-count" id="prodPoints"> {{ infoPoints }} </span>
                    </div>
                    <div class="line-col last" :class="{'two-rows' : detailedInfo.frozenText}">
                        <p v-if="detailedInfo.frozenText" class="frozen-info">
                            <i class="prz-frozen"/>
                            <span> {{ detailedInfo.frozenText }} </span>
                        </p>
                        <div v-if="deliveryInfo && deliveryInfo.renderDeliveryInfo" class="delivery-info">
                            <Popper v-if="deliveryInfo.postalCode" trigger="clickToToggle" position="top">
                                <div class="delivery-notice" slot="activator">
                                    <i class="prz-local-shipping"/>
                                    <span class="delivery-time"> {{ deliveryInfo.serviceDescription }} </span>
<!--                                    <i v-if="!deliveryInfo.postalCode" class="prz-error notice-icon" />-->
                                </div>
                                <div class="delivery-tooltip">
                                    <p class="dlv-tooltip-description"> {{ deliveryInfo.serviceTooltip ? deliveryInfo.serviceTooltip : kStrings.kENTER_POSTAL_CODE_INFO }} </p>
                                </div>
<!--                                <div v-else class="delivery-tooltip link" @click="toggleCPModal">
                                    <h3 class="dlv-tooltip-title"> {{ kStrings.kENTER_POSTAL_CODE }} </h3>
                                    <p class="dlv-tooltip-description"> {{ kStrings.kENTER_POSTAL_CODE_INFO }} </p>
                                </div>-->
                            </Popper>
                            <div v-else class="delivery-notice" @click="toggleCPModal()">
                                <i class="prz-local-shipping"/>
                                <span class="delivery-time"> {{ deliveryInfo.serviceDescription }} </span>
                                <i  class="prz-error notice-icon" />
                            </div>
                        </div>
                        <div v-else-if="stockMsg" class="stock-info" :class="{'alert-notice' : !hasStock || (productStatus == 'TI' || overrideDetail), 'orange-level' : productStatus == 'TI' || overrideDetail}">
                            <i v-if="!hasStock || (productStatus == 'TI' || overrideDetail)" :class="[productStatus != 'TI' ? 'prz-error' : 'prz-alert']"/>
                            {{ stockMsg }}
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-else class="minimal-info">
            <div class="line-of-infos first">
                <h1 class="col product-name"> {{ detailedInfo.name }} </h1>
                <div class="col-auto empty-section medium"/>
                <div class="col-auto empty-section medium"/>
            </div>
            <div class="line-of-infos middle">
                <div class="col-auto flex-start"> <div class="empty-section col-6"/> <div class="empty-section"/> </div>
                <div class="col-auto flex-center"> <div class="empty-section"/> <div class="empty-section col-3"/> </div>
                <div class="col-auto flex-end"> <div class="empty-section"/> <div class="empty-section col-9"/> </div>
            </div>
            <div class="line-of-infos last-row">
                <div class="col-auto empty-section big"/>
                <div class="col-auto empty-section big"/>
            </div>
            <div class="fake-carousel-wrapper">
                <div class="line-of-infos">
                    <div class="fake-option empty-section"/>
                </div>
                <div class="fake-carousel">
                    <div class="fake-item active"> <div class="fake-img"/> <div class="fake-desc"/> </div>
                    <div class="fake-item"> <div class="fake-img"/> <div class="fake-desc"/> </div>
                    <div class="fake-item"> <div class="fake-img"/> <div class="fake-desc"/> </div>
                    <div class="fake-item"> <div class="fake-img"/> <div class="fake-desc"/> </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <BlockContentPopup
                v-if="openCpgModal"
                :modal-mode="true"
                id="priceCpgModal"
                class="cpg-popup"
                :stacked-modal="true"
                @close="openCpgModal = false"
            >
                <template v-slot:content>
                    <CampaignDisplay v-if="openCpgModal" :campaign="couponData" :kStrings="kStrings" :stacked-modal="true" @close="openCpgModal = false"/>
                </template>
            </BlockContentPopup>
        </transition>
    </div>
</template>

<script>
import Popper from '../../../Muffin/Popper.vue';
import {storePdp} from '@/store/product-page';
import Rating from '@/components/Muffin/Rating.vue';
import Likes from '@/components/Muffin/Like.vue';
import BlockContentPopup from "@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue";
import CampaignDisplay from "@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/CampaignDisplay.vue";

import pdpEvents from '@/Utilities/events-pdp/events';

import {isEmpty} from 'lodash-es';
import utilities from '@/Utilities/common';

export default {
    storePdp,
    name: 'InfoSection',
    components: {
        Popper,
        Rating,
        Likes,
        CampaignDisplay,
        BlockContentPopup,
    },
    props: {
        detailedInfo: {
            type: Object,
            default: null
        },
        kStrings: {
            type: Object,
            default: {}
        },
        showCopyLink: {
            type: Boolean,
            default: false
        },
        scrollMinimalMode: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            classSuperPoints: {
                play: false
            },
            showCopyMsg: false,
            openCpgModal: false,
        }
    },
    created() {
        setTimeout(() => {
            this.classSuperPoints = {
                play: true
            }
        },10);
    },
    watch: {},
    computed: {
        stockMsg(){
            if(!this.showStockLabel) return '';
            let msg = storePdp.getters.stockLabel;
            if(!msg || this.productStatus == 'TI') {
                msg = this.basicInfo.stockMsg;
            }

            return msg;
        },
        showStockLabel() {
            return storePdp.getters.showStockLabel;
        },
        selectedProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedProduct'];
        },
        productStatus() {
            if(!isEmpty(this.selectedProduct) && !this.selectedProduct.overrideStatus) {
                return this.selectedProduct.status;
            }
            return storePdp.getters['pdpDesktop/addToCartDesktop/productStatus'];
        },
        overrideDetail() {
            if(this.selectedProduct && this.selectedProduct.overrideStatus && this.selectedProduct.overrideStatus.hasOwnProperty('reasonDetail')) {
                return this.selectedProduct.overrideStatus.reasonDetail;
            }

            return null;
        },
        price(){
            //return this.addToCartData.productInfo.minPrice;
            const data = storePdp.getters.priceData;
            if(typeof(data.price)!="undefined"){
                return data.price ? data.price : null;
            }
            return this.detailedInfo.priceData.price ? this.detailedInfo.priceData.price : null;
        },
        priceReference(){
            const data = storePdp.getters.priceData;
            return data.priceReference ? data.priceReference : null;
        },
        bestPriceCoupon(){
            const data = storePdp.getters.priceData;
            return data.bestPriceCoupon ? data.bestPriceCoupon : null;
        },
        hasStock(){
            return typeof storePdp.getters.hasStock !== "undefined" ? storePdp.getters.hasStock : this.basicInfo.hasStock;
        },
        couponData(){
            const couponId = this.bestPriceCoupon;
            if(couponId){
                const groupId = storePdp.getters.GroupId;
                const coupon = storePdp.getters['priceCoupons/getCoupon'](couponId, groupId);
                if(coupon && coupon.labelHtml){
                    return coupon;
                }
            }
            return null;
        },
        deliveryInfo() {
            if(!this.hasStock) {
                return null;
            }

            return !isEmpty(storePdp.getters.deliveryInfo) ? storePdp.getters.deliveryInfo : null;
        },
        infoPoints() {
            return Math.trunc(this.detailedInfo.points * this.detailedInfo.prozisPointsFactor);
        },
        superPoints(){
            return this.detailedInfo.hasOwnProperty('superPoints') ? this.detailedInfo.superPoints : 0;
        },
        basicInfo() {
            return storePdp.getters['pdpDesktop/basicInfoData'];
        },
        fanLinkData(){
            return null;
            /* const fanLinkData = this.detailedInfo.fanLinkData;
             return this.mode != 'sample-product' && fanLinkData && Object.keys(fanLinkData).length ? fanLinkData : null;*/
        },
        renderLineInfo() {
            if(this.productStatus == 'NV') {
                return false;
            }

            return this.isActive || (!this.basicInfo.isDisabled && !this.basicInfo.isSampleProduct);
        },
        pointsUrl() {
            return storePdp.getters['pdpDesktop/pointsUrl'];
        }
    },
    methods: {
        toggleCPModal() {
            openModal('postalDelivery');
        },
        onLikeChange({itemId, liked}){
            // close object (using JSON parse/stringify to deep clone object)
            let updatedData = JSON.parse(JSON.stringify(this.detailedInfo.likesData));
            updatedData.liked = liked;
            storePdp.commit('pdpDesktop/updateInfoSectionPartial', {likesData: updatedData});
            //storePdp.commit('pdpDesktop/updateLike', {liked: liked}); // does not work well
            pdpEvents.addLike(storePdp.getters.GroupId, liked);
        },
        tabOpen(key) {
            this.$emit('force-load-tab', key);
        },
        async copyPageLink() {
            try {
                await navigator.clipboard.writeText(location.href);
                this.showCopyMsg = true;
                setTimeout(() => {
                    this.showCopyMsg = false;
                }, 3000);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
        goToPointsUrl(){
            if(this.pointsUrl){
                utilities.goToUrl(this.pointsUrl);
            }
        },
        // for accordion transitions with dynamic content
        /**
         * @param {HTMLElement} element
         */
        beforeEnter(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = '0px';
                }

                element.style.display = null;
            });
        },
        /**
         * @param {HTMLElement} element
         */
        enter(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = `${element.scrollHeight}px`;
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterEnter(element) {
            element.style.height = null;
        },
        /**
         * @param {HTMLElement} element
         */
        beforeLeave(element) {
            requestAnimationFrame(() => {
                if (!element.style.height) {
                    element.style.height = `${element.offsetHeight}px`;
                }
            });
        },
        /**
         * @param {HTMLElement} element
         */
        leave(element) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    element.style.height = '0px';
                });
            });
        },
        /**
         * @param {HTMLElement} element
         */
        afterLeave(element) {
            element.style.height = null;
        },
    }
}
</script>

<style lang="scss">
@import "../styles/infoSection";
</style>
